import { css, CSSObject, Interpolation, RuleSet } from 'styled-components';

import GridTheme from '../gridTheme';

// Getting breakpoints from GridTheme
const sizes = GridTheme.flexboxgrid.breakpoints;

export type MediaValue = (
  first: TemplateStringsArray | CSSObject,
  ...args: Interpolation<object>[]
) => RuleSet<object>;

/**
 * @deprecated use media instead
 */
const media = Object.keys(sizes).reduce<{
  [key: string]: MediaValue;
}>((acc, label) => {
  acc[label] = (
    first: TemplateStringsArray | CSSObject,
    ...args: Interpolation<object>[]
  ) => css`
    @media (min-width: ${sizes[label]}em) {
      ${css(first, ...args)}
    }
  `;

  return acc;
}, {});

export default media;
